/* DAYS Comfy bundle builder: 1 pair, 2 pairs, or the top pack (default 3+1 = 4 pairs), a colour per pair and
   one size for all (default) or a size per pair (Mix & Match). Every pair's size dropdown is always visible:
   while "same size for all" is ticked, pair 1's size is copied to every pair, and changing a lower pair's size
   unticks it and keeps that pair's own choice. Adds the real variants in one /cart/add.js call;
   the pack prices are Shopify automatic discounts. */
(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const ord = (n) => n + 'ο';

  function initBuilder(el) {
    if (el.dataset.dcReady) return;
    el.dataset.dcReady = '1';
    const dataEl = el.querySelector('script[data-dc-data]');
    if (!dataEl) return;
    const data = JSON.parse(dataEl.textContent);
    const S = data.strings;
    const q1 = (s) => el.querySelector(s);
    const qa = (s) => Array.from(el.querySelectorAll(s));
    const tierEls = qa('[data-dc-tier]');
    const pairEls = qa('[data-dc-pair]');
    const pairsBox = q1('[data-dc-pairs]');
    const sameRow = q1('[data-dc-same-row]');
    const sameBox = q1('[data-dc-same]');
    const globalSel = q1('[data-dc-global-size]');
    const globalMsg = q1('[data-dc-global-msg]');
    const atc = q1('[data-dc-atc]');
    const atcLabel = q1('[data-dc-atc-label]');
    const atcWas = q1('[data-dc-atc-was]');
    const atcSub = q1('[data-dc-atc-sub]');
    const atcSave = q1('[data-dc-atc-save]');
    const atcError = q1('[data-dc-atc-error]');
    const sticky = document.querySelector('[data-dc-sticky="' + data.sectionId + '"]');
    const variantBy = new Map(data.variants.map((v) => [v.c + '|' + v.s, v]));
    const colourMedia = {};
    data.variants.forEach((v) => { if (v.m && !colourMedia[v.c]) colourMedia[v.c] = v; });

    const state = {
      tier: data.defaultTier,
      same: sameBox ? sameBox.checked : false,
      size: '',
      pairs: pairEls.map((p) => ({ colour: p.dataset.defaultColour, size: p.querySelector('[data-dc-size]').value || '', touched: false }))
    };
    const tier = (n) => data.tiers[String(n)];
    const avail = (c, s) => { const v = variantBy.get(c + '|' + s); return !!(v && v.a); };
    if (state.same) state.size = state.pairs[0].size;
    const effSize = (i) => (state.same ? state.size : state.pairs[i].size);
    // keep the visible pair dropdowns in step with the state
    function syncSelects() {
      if (state.same) state.pairs.forEach((p) => { p.size = state.size; });
      pairEls.forEach((p, i) => { const sel = p.querySelector('[data-dc-size]'); if (sel.value !== state.pairs[i].size) sel.value = state.pairs[i].size; });
      if (globalSel) globalSel.value = state.size;
    }

    function render() {
      const t = tier(state.tier);
      tierEls.forEach((x) => x.setAttribute('aria-checked', String(Number(x.dataset.dcTier) === state.tier)));
      pairsBox.classList.toggle('is-same', state.same);
      if (sameBox) sameBox.checked = state.same;
      pairEls.forEach((p, i) => {
        p.hidden = i >= t.qty;
        const free = p.querySelector('[data-dc-free-badge]');
        if (free) free.hidden = !(i >= t.paid && i < t.qty);
        const size = effSize(i);
        p.querySelectorAll('[data-dc-swatch]').forEach((sw) => {
          const c = sw.dataset.dcSwatch;
          const out = !!size && !avail(c, size);
          sw.classList.toggle('is-soldout', out);
          sw.setAttribute('aria-checked', String(c === state.pairs[i].colour));
          sw.title = out ? c + ' · ' + S.soldOutShort : c;
        });
        p.querySelector('[data-dc-colour-label]').textContent = state.pairs[i].colour;
        Array.from(p.querySelector('[data-dc-size]').options).forEach((o) => {
          if (!o.value) return;
          const ok = avail(state.pairs[i].colour, o.value);
          o.disabled = !ok;
          o.textContent = o.dataset.label + (ok ? '' : ' · ' + S.soldOutShort);
        });
      });
      atcLabel.textContent = S.atc.replace('[price]', t.total);
      if (atcSub) {
        atcSub.hidden = !t.pct;
        if (atcWas) atcWas.textContent = t.was || '';
        if (atcSave) atcSave.textContent = t.pct ? S.atcSave.replace('[amount]', t.save).replace('[percent]', String(t.pct)) : '';
      }
      if (sticky) {
        sticky.querySelector('[data-dc-sticky-tier]').textContent = t.title;
        sticky.querySelector('[data-dc-sticky-price]').textContent = t.total;
        const pctEl = sticky.querySelector('[data-dc-sticky-pct]');
        if (pctEl) { pctEl.hidden = !t.pct; pctEl.textContent = t.pct ? '-' + t.pct + '%' : ''; }
      }
      tierEls.forEach((tEl) => {
        tEl.querySelectorAll('[data-dc-thumb]').forEach((img, i) => {
          const c = state.pairs[i] && state.pairs[i].colour;
          if (c && data.swatches[c] && img.getAttribute('src') !== data.swatches[c]) img.setAttribute('src', data.swatches[c]);
        });
      });
    }

    // Pairs the shopper has not touched keep their default colour when it is in stock in the chosen size,
    // otherwise they move to another colour that is (a different one where possible).
    function autoFixColours() {
      const qty = tier(state.tier).qty;
      const used = new Set();
      for (let i = 0; i < qty; i++) {
        const p = state.pairs[i];
        const size = effSize(i);
        if (p.touched) { used.add(p.colour); continue; }
        const def = pairEls[i].dataset.defaultColour;
        if (!size || avail(def, size)) { p.colour = def; used.add(def); continue; }
        const pick = data.colours.find((c) => avail(c, size) && !used.has(c)) || data.colours.find((c) => avail(c, size));
        if (pick) p.colour = pick;
        used.add(p.colour);
      }
    }

    function validate(showEmpty) {
      const t = tier(state.tier);
      let first = null;
      let gErr = '';
      if (globalMsg) { globalMsg.textContent = gErr; globalMsg.hidden = true; }
      if (sameRow) sameRow.classList.remove('is-invalid');
      pairEls.forEach((p, i) => {
        const msg = p.querySelector('[data-dc-msg]');
        let err = '';
        if (i < t.qty) {
          const size = effSize(i);
          if (!size) {
            if (showEmpty && !state.same) err = S.chooseSize.replace('[n]', ord(i + 1));
            else if (showEmpty && i === 0) err = S.chooseSizeAll;
          }
          else if (!avail(state.pairs[i].colour, size)) err = S.soldOut.replace('[size]', size).replace('[colour]', state.pairs[i].colour);
        }
        p.classList.toggle('is-invalid', !!err);
        msg.textContent = err;
        msg.hidden = !err;
        if (err && !first) first = p;
      });
      return first;
    }

    function showColourInGallery(colour) {
      const v = colourMedia[colour];
      const form = document.forms[data.formId];
      if (!v || !v.m || !form) return;
      form.dispatchEvent(new CustomEvent('variant:change', {
        detail: { formId: data.formId, variant: { id: v.id, featured_media: { id: v.m.id, position: v.m.position } }, previousVariant: null }
      }));
    }

    function setTier(n) {
      state.tier = n;
      atcError.hidden = true;
      autoFixColours();
      render();
      validate(false);
    }

    function setSame(on) {
      if (on) state.size = state.pairs[0].size || state.size || '';
      if (!on) state.pairs.forEach((p) => { if (!p.size) p.size = state.size; });
      state.same = on;
      syncSelects();
      autoFixColours();
      render();
      validate(false);
    }

    function pickGift() {
      if (!data.gift) return null;
      const size = effSize(0) || '';
      const lo = parseInt((size.match(/\d+/) || ['0'])[0], 10);
      const open = data.gift.variants.filter((v) => v.a);
      if (!open.length) return null;
      const fit = open.find((v) => { const m = v.t.match(/(\d+)\D+(\d+)/); return m && lo >= Number(m[1]) && lo <= Number(m[2]); });
      return fit || open[open.length - 1];
    }

    function busy(on) {
      [atc, sticky && sticky.querySelector('[data-dc-sticky-btn]')].forEach((b) => {
        if (!b) return;
        if (on) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy');
      });
    }

    function showError(text) {
      atcError.textContent = text || S.error;
      atcError.hidden = false;
    }

    function nativeFallback(items) {
      const f = document.createElement('form');
      f.method = 'post';
      f.action = root + 'cart/add';
      items.forEach((it, i) => {
        [['id', it.id], ['quantity', it.quantity]].forEach(([k, v]) => {
          const input = document.createElement('input');
          input.type = 'hidden'; input.name = 'items[' + i + '][' + k + ']'; input.value = v;
          f.appendChild(input);
        });
      });
      document.body.appendChild(f);
      HTMLFormElement.prototype.submit.call(f);
    }

    async function addToCart() {
      atcError.hidden = true;
      const bad = validate(true);
      if (bad) {
        bad.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const focusEl = bad.querySelector('[data-dc-size]');
        setTimeout(() => focusEl && focusEl.focus({ preventScroll: true }), 450);
        return;
      }
      const t = tier(state.tier);
      const counts = new Map();
      for (let i = 0; i < t.qty; i++) {
        const v = variantBy.get(state.pairs[i].colour + '|' + effSize(i));
        counts.set(v.id, (counts.get(v.id) || 0) + 1);
      }
      const items = Array.from(counts, ([id, quantity]) => ({ id, quantity }));

      busy(true);
      if (t.gift) {
        const g = pickGift();
        if (g) {
          let hasGift = false;
          try {
            const c = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();
            hasGift = c.items.some((it) => it.product_id === data.gift.productId);
          } catch (e) { /* add it */ }
          if (!hasGift) items.push({ id: g.id, quantity: 1 });
        }
      }

      const sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
      let res;
      try {
        res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items, sections: sections.join(','), sections_url: window.location.pathname })
        });
      } catch (e) {
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
        nativeFallback(items);
        return;
      }
      try {
        const json = await res.json();
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
        if (!res.ok) {
          showError(json.description || json.message);
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          return;
        }
        const settings = (window.themeVariables && window.themeVariables.settings) || {};
        if (settings.cartType === 'page' || !document.querySelector('cart-drawer')) {
          window.location.href = root + 'cart';
          return;
        }
        const cart = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();
        cart.sections = json.sections;
        const form = document.forms[data.formId] || document.documentElement;
        form.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: json.items || [json], cart, onSuccessDo: 'force_open_drawer' } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', onSuccessDo: 'force_open_drawer', cart } }));
      } catch (e) {
        window.location.href = root + 'cart';
      } finally {
        busy(false);
      }
    }

    // wiring
    tierEls.forEach((x) => x.addEventListener('click', () => setTier(Number(x.dataset.dcTier))));
    pairEls.forEach((p, i) => {
      p.querySelectorAll('[data-dc-swatch]').forEach((sw) => sw.addEventListener('click', () => {
        state.pairs[i].colour = sw.dataset.dcSwatch;
        state.pairs[i].touched = true;
        render();
        validate(false);
        showColourInGallery(sw.dataset.dcSwatch);
      }));
      p.querySelector('[data-dc-size]').addEventListener('change', (e) => {
        const val = e.target.value;
        if (state.same && i === 0) {
          state.size = val;
          syncSelects();
          autoFixColours();
        } else if (state.same) {
          setSame(false);
          state.pairs[i].size = val;
          syncSelects();
        } else {
          state.pairs[i].size = val;
        }
        render();
        validate(false);
      });
    });
    if (globalSel) globalSel.addEventListener('change', (e) => {
      state.size = e.target.value;
      autoFixColours();
      render();
      validate(false);
    });
    if (sameBox) sameBox.addEventListener('change', () => setSame(sameBox.checked));
    qa('[data-dc-set-mix]').forEach((b) => b.addEventListener('click', () => setSame(false)));
    qa('[data-dc-set-same]').forEach((b) => b.addEventListener('click', () => setSame(true)));
    atc.addEventListener('click', addToCart);

    const dialog = q1('[data-dc-dialog]');
    if (dialog) {
      qa('[data-dc-open-guide]').forEach((b) => b.addEventListener('click', () => {
        if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
      }));
      dialog.querySelectorAll('[data-dc-close]').forEach((b) => b.addEventListener('click', () => dialog.close()));
      dialog.addEventListener('click', (e) => { if (e.target === dialog) dialog.close(); });
    }

    if (sticky) {
      sticky.querySelector('[data-dc-sticky-btn]').addEventListener('click', addToCart);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting)).observe(atc);
      }
    }

    // "Mix your bundle" buttons elsewhere on the page: top pack, a size per pair
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-dc-mix]');
      if (!trigger) return;
      e.preventDefault();
      state.tier = Number(trigger.dataset.dcMix) || 3;
      setSame(false);
      pairsBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    syncSelects();
    autoFixColours();
    render();
    validate(false);
  }

  function boot() { document.querySelectorAll('[data-dc-builder]').forEach(initBuilder); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
